import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./Listings.css";
import PropertySingleLine from "./PropertySingleLine";
import PropertyAgentFullPage from "./PropertyAgentFullPage";
//import properties from "./properties.json";
import { PropertyAPI } from "./lib/property-api";
import { PropertiesFile } from "./types";
import { SavedRow, Status, SortMode, ViewMode } from "./types";
import { DisplayMode } from "./types";
import PropertyThumbnail from "./PropertyThumbnail";
import PropertySingleLineHeader from "./PropertySingleLineHeader";
import { initGlobalState } from "./CrappyGlobalState";
import { shouldShowHeader } from "./ViewMode";
import { PropertySource } from "./lib/property-api";
import { get_source } from "./lib/source";
import { to_saved_row } from "./lib/to-saved-row";

const dd = console.debug;
interface Props {
  display_mode: DisplayMode;
  sort_mode: SortMode;
}

const ignore: Array<string> = [];
function Listings(props: Props) {
  const [soldKeys, setSoldKeys] = React.useState<Array<string>>([]);
  const [activeKeys, setActiveKeys] = React.useState<Array<string>>([]);
  const [sortMode, setSortMode] = React.useState<SortMode>("highest-first");
  const [viewMode, setViewMode] = React.useState<ViewMode>("icons");
  const [loading, setLoading] = React.useState<boolean>(true);
  const [displayMode, setDisplayMode] = React.useState<DisplayMode>(props.display_mode);
  const [properties,setProperties] = React.useState<PropertiesFile|null>(null);
  const [api,_] = React.useState<PropertyAPI>(new PropertyAPI());
  const [selectAllThumbnails, setSelectAllThumbnails] =
    React.useState<boolean>(false);
  const [source,setSource] = React.useState<PropertySource>('onekey');
  function sortByNewest(status: Status | Array<Status>): Array<SavedRow> {
    let sorted: Array<SavedRow> = [];
    for (const key in properties) {
      if (ignore.includes(key)) {
        continue;
      }
      /** @ts-ignore */
      if (Array.isArray(status) && status.includes(properties[key].MlsStatus)) {
        sorted.push(properties[key]);
      } else if (properties[key].MlsStatus === status) {
        sorted.push(properties[key]);
      }
    }

    return sorted.sort((a: SavedRow, b: SavedRow) => {
      if (a.OnMarketDate !== null && b.OnMarketDate !== null) {
        const a_date: Date = new Date(a.OnMarketDate);
        const b_date: Date = new Date(b.OnMarketDate);
        return b_date.getTime() - a_date.getTime();
      }
      return 0;
    });
  }
  function sortByHighestPrice(status: Status | Array<Status>): Array<SavedRow> {
    let sorted: Array<SavedRow> = [];
    dd(properties,'<<< properties');
    for (const key in properties) {
      if (ignore.includes(key)) {
        continue;
      }
      /** @ts-ignore */
      if (Array.isArray(status) && status.includes(properties[key].MlsStatus)) {
        sorted.push(properties[key]);
      } else if (properties[key].MlsStatus === status) {
        sorted.push(properties[key]);
      }
    }

    return sorted.sort((a: SavedRow, b: SavedRow) => {
      return Number(b.ListPrice) - Number(a.ListPrice);
    });
  }
  function sortByLowestPrice(status: Status | Array<Status>): Array<SavedRow> {
    let sorted: Array<SavedRow> = [];
    for (const key in properties) {
      if (ignore.includes(key)) {
        continue;
      }
      /** @ts-ignore */
      if (Array.isArray(status) && status.includes(properties[key].MlsStatus)) {
        sorted.push(properties[key]);
      } else if (properties[key].MlsStatus === status) {
        sorted.push(properties[key]);
      }
    }

    return sorted.sort((a: SavedRow, b: SavedRow) => {
      return Number(a.ListPrice) - Number(b.ListPrice);
    });
  }
  React.useEffect(() => {
    initGlobalState();

    global.lombardo.selected = [];
    if (selectAllThumbnails) {
      for(const key in properties){
        if(['show-active','show-all'].includes(displayMode) && ['Active','Pending',].includes(properties[key].MlsStatus) && global.lombardo.selected.indexOf(key) === -1){
          global.lombardo.selected.push(key);
        }
        if(['show-sold','show-all'].includes(displayMode) && ['Sold',].includes(properties[key].MlsStatus) && global.lombardo.selected.indexOf(key) === -1){
          global.lombardo.selected.push(key);
        }
      }
    }
    document
      .querySelectorAll("[data-thumbnailproperty]")
      .forEach((value: Element) => {
        const btn: HTMLButtonElement = value as HTMLButtonElement;
        if (selectAllThumbnails && btn.dataset.state === "off") {
          btn.click();
          return;
        }
        if (!selectAllThumbnails && btn.dataset.state === "on") {
          btn.click();
          return;
        }
      });
  }, [selectAllThumbnails]);

  React.useEffect(() => {
    (async () => {
      //setProperties({});
      initGlobalState();
      setLoading(true);
      setSelectAllThumbnails(false);
      const url: URL = new URL(window.location.href);
      url.searchParams.delete("backDisplayMode");
      setLoading(true);
      const source = get_source();
      setSource(source);
      let tmp = await api.get_active_by_source(source);
      let active: Array<SavedRow> = to_saved_row(tmp);
      let sold: Array<SavedRow> = to_saved_row(await api.get_sold_by_source(source));
      setActiveKeys(active.map((value: SavedRow) => value.ListingKey));
      setSoldKeys(sold.map((value: SavedRow) => value.ListingKey));
      dd({active,sold});
      setProperties(tmp);
      const disp_mode: string =
        url.searchParams.get("displayMode") ?? "show-active";
      switch (disp_mode) {
        case "show-active":
        case "show-sold":
        case "property":
          setDisplayMode(disp_mode);
          break;
        default:
          setDisplayMode("show-active");
          break;
      }
      const str: string = url.searchParams.get("sortMode") ?? "";
      switch (str) {
        case "newest":
        case "highest-first":
        case "lowest-first":
          setSortMode(str);
          break;
        default:
          setSortMode("highest-first");
          break;
      }
      {
        const str: string = url.searchParams.get("viewMode") ?? "icons";
        switch (str) {
          case "single-line":
          case "icons":
          case "agent-full-page":
            setViewMode(str);
            break;
          default:
            setViewMode("icons");
            break;
        }
      }
      setLoading(false);
    })();
  }, []);
  React.useEffect(() => {
    setLoading(true);
    let active: Array<SavedRow> = [];
    let sold: Array<SavedRow> = [];
    if (sortMode === "highest-first") {
      active = sortByHighestPrice(["Active", "Pending"]);
      sold = sortByHighestPrice("Sold");
    }
    if (sortMode === "lowest-first") {
      active = sortByLowestPrice(["Active", "Pending"]);
      sold = sortByLowestPrice("Sold");
    }
    if (sortMode === "newest") {
      active = sortByNewest(["Active", "Pending"]);
      sold = sortByNewest("Sold");
    }
    setActiveKeys(active.map((value: SavedRow) => value.ListingKey));
    setSoldKeys(sold.map((value: SavedRow) => value.ListingKey));
    setLoading(false);
  }, [sortMode]);

  return (
    <div className="App container Listings">
      <div className="content-area container col-md-12 border-1" id="overview">
        <h1 className="heading-h1 top-banner-page h1-custom-override no-print">
          {["show-active"].includes(props.display_mode) && (
            <>Active Properties</>
          )}
          {["show-sold"].includes(props.display_mode) && <>Sold Properties</>}
        </h1>
        {props.display_mode !== "property" && (
          <div className="sort-select-wrapper no-print">
            <h4 className="select-label">View As:</h4>
            <div className="select-wrapper">
              <select
                value={viewMode}
                className="sort-by-select"
                onChange={(e) => {
                  const view: string = (e.target as HTMLSelectElement).value;
                  switch (view) {
                    case "agent-full-page":
                      setViewMode("agent-full-page");
                      break;
                    case "single-line":
                      setViewMode("single-line");
                      break;
                    case "icons":
                      setViewMode("icons");
                      break;
                    default:
                      setViewMode("icons");
                      break;
                }
                const url: URL = new URL(window.location.href);
                url.searchParams.set("viewMode", view);
                url.searchParams.set("displayMode", displayMode);
                window.location.href = url.toString();
                }}
              >
                <option value="icons" selected={viewMode === "icons"}>
                  Thumbnails
                </option>
                <option
                  value="agent-full-page"
                  selected={viewMode === "agent-full-page"}
                >
                  Agent Full Page
                </option>
                <option
                  value="single-line"
                  selected={viewMode === "single-line"}
                >
                  Single Line
                </option>
              </select>
            </div>
          </div>
        )}
        {shouldShowHeader(viewMode, displayMode) && (
          <PropertySingleLineHeader view_mode={viewMode} properties={properties} />
        )}
        {viewMode === "icons" && displayMode !== "property" && (
          <div className="icons-select-wrapper">
            <button
              className="thumb-select-all share-button-generic"
              onClick={() => {
                setSelectAllThumbnails(true);
              }}
            >
              Select All
            </button>
            <button
              className="thumb-select-none share-button-generic"
              onClick={() => {
                setSelectAllThumbnails(false);
              }}
            >
              Select None
            </button>
          </div>
        )}
        {viewMode === "icons" && (
          <div className="row">
            {loading &&
              ["show-sold", "show-active"].includes(props.display_mode) && (
                <div className="listings-loading-section no-print">
                  Loading...
                </div>
              )}
            {!loading &&
                ["show-sold"].includes(props.display_mode) &&
                soldKeys.map((value: string) => (
                  <div className="thumbnail-wrapper col-md-4 col-sm-6 col-lg-3 col-12">
                    <PropertyThumbnail
                      property_id={value}
                      sort_mode={sortMode}
                      display_mode={displayMode}
                      show_share_property_icons={true}
                      source={source}
                    />
                  </div>
                ))}
            {!loading &&
                ["show-active"].includes(props.display_mode) &&
                activeKeys.map((value: string) => (
                  <div className="thumbnail-wrapper col-md-4 col-sm-6 col-lg-3 col-12">
                    <PropertyThumbnail
                      property_id={value}
                      sort_mode={sortMode}
                      display_mode={displayMode}
                      show_share_property_icons={true}
                      source={source}
                    />
                  </div>
                ))}
          </div>
        )}
        <div className="left-adjust">
          {viewMode === "agent-full-page" &&
            ["show-active", "show-all"].includes(displayMode) &&
            <PropertyAgentFullPage/>
          }
        </div>
        <div className="left-adjust">
          {viewMode === "single-line" &&
            ["show-active", "show-all"].includes(displayMode) &&
            activeKeys.map((value: string) => {
              return (
                <PropertySingleLine
                  property_id={value}
                  sort_mode={sortMode}
                  display_mode={displayMode}
                  source={get_source()}
                />
              );
          })
          }
          {viewMode === "single-line" &&
              ["show-sold", "show-all"].includes(displayMode) &&
              soldKeys.map((value: string) => {
                return (
                  <PropertySingleLine
                    property_id={value}
                    sort_mode={sortMode}
                    display_mode={displayMode}
                    source={get_source()}
                  />
                );
          })
          }
        </div>
        <div className="sort-select-wrapper no-print"></div>
      </div>
    </div>
  );
}

export default Listings;
